import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import MainMenuItem from './MainMenuItem';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as mainMenuActions from '../../../actions/mainMenuActions';
import * as actionTypes from '../../../actions/actionTypes';
import {getScreenUserData} from '../../../helpers/userDataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import _ from 'lodash';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';


class MainMenuAccordionBtn extends React.Component{

    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.screen),
            bite: appHelper.getBiteById(this.props.bite_id),
            userBite: this.props.userBite,
            userScreen: this.props.userScreen,
            screen_status: this.props.userScreen.status,
            section_status: objectConstants.STATUS_NOT_STARTED,
            //current_screen_id: this.props.current_screen_id,
            current_screen_id:this.props.trackingData.lesson_location,
            is_current_section: false,
            accordionIsOpen: false,
            canClickMenu: false,
            isEnabled: false,
            checkEnabledState: false,
            setLocale: false,
        };

        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.hideAccordionMenu = this.hideAccordionMenu.bind(this);
        this.showAccordionMenu = this.showAccordionMenu.bind(this);
        this.onMenuHandledComplete = this.onMenuHandledComplete.bind(this);
        this.setSectionProgress = this.setSectionProgress.bind(this);
        this.isCurrentSection = this.isCurrentSection.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIsActive = this.setIsActive.bind(this);
        this.loadScreen = this.loadScreen.bind(this);
        this.setEnabledState = this.setEnabledState.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.loadScreenByKeyboardAccessibility = this.loadScreenByKeyboardAccessibility.bind(this);
        this.getLocale = this.getLocale.bind(this);
    }

    componentDidMount(){
        this.setEnabledState();
        this.isCurrentSection();
        this.setSectionProgress();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userBite !== nextProps.userBite) {
            this.setState({
                userBite: Object.assign({}, nextProps.userBite),
                userScreen: Object.assign({}, nextProps.userScreen),
                screen_status: nextProps.userScreen.status,
                checkEnabledState: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: Object.assign({}, appHelper.getLocalData(this.props.screen))
            });
        }
    }

    componentDidUpdate(){
        if(this.state.checkEnabledState){
            this.setEnabledState();
        }

        if(this.state.setLocale){
            this.getLocale();
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale), setLocale: false});
    }

    setEnabledState(){

        let isEnabled = false;
        if(this.state.bite.navigation_type === objectConstants.LINEAR){
            isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen,this.state.userBite);
        }else{
            isEnabled = true;
        }

        this.setState({
            checkEnabledState: false,
            isEnabled: isEnabled
        });
    }

    isCurrentSection(){

        let isCurrentSection =  this.props.screen.childScreens.filter(obj => obj.screen_id === this.state.current_screen_id).length > 0;
        this.setState({
            is_current_section: isCurrentSection

        });
        if(isCurrentSection && !appHelper.isDefined(this.props.screen.show_children_screens_in_menu)  || (appHelper.isDefined(this.props.screen.show_children_screens_in_menu) && this.props.screen.show_children_screens_in_menu)){
            this.showAccordionMenu();
        }

        this.setSectionProgress();
    }

    setSectionProgress(){
        let status = objectConstants.STATUS_NOT_STARTED;
        let not_started_screens = 0;
        let not_required_screens = 0;
        let in_progress_screens = 0;
        let completed_screens = 0;


        for(let i = 0; i < this.props.screen.childScreens.length; i++){
            let screen = this.props.screen.childScreens[i];
            let userScreen = getScreenUserData(this.props.userData, screen.screen_id);
            if(userScreen.status === objectConstants.STATUS_NOT_STARTED){
                not_started_screens++;
            }else if(userScreen.status === objectConstants.STATUS_NOT_REQUIRED){
                not_required_screens++;
            }else if(userScreen.status === objectConstants.STATUS_IN_PROGRESS){
                in_progress_screens++;
            }else if(userScreen.status === objectConstants.STATUS_COMPLETE){
                completed_screens++;
            }
        }

        let complete_and_non_required_screens = completed_screens + not_required_screens;

        if(complete_and_non_required_screens === this.props.screen.childScreens.length && not_required_screens < completed_screens){
            status = objectConstants.STATUS_COMPLETE;
        }else if(not_required_screens === this.props.screen.childScreens.length){
            status = objectConstants.STATUS_NOT_REQUIRED;
        }else if(in_progress_screens > 0 || completed_screens > 0) {
            status = objectConstants.STATUS_IN_PROGRESS;
        }
        this.setState({section_status: status});
    }

    toggleAccordion(){
        if(this.state.isEnabled) {
            if (this.state.accordionIsOpen) {
                this.hideAccordionMenu();
            } else {
                this.showAccordionMenu();
            }
        }
    }

    hideAccordionMenu() {
        this.setState({accordionIsOpen: false, canClickMenu: false});
        let mainMenu = this.refs[`accordion_${this.props.screen.screen_id}`];
        TweenLite.to(mainMenu, objectConstants.ACCORDION_BUTTON_DURATION, {height: 0, ease: Expo.easeInOut}).eventCallback("onComplete", this.onMenuHandledComplete);
    }

    showAccordionMenu(){
        this.setState({accordionIsOpen: true, canClickMenu: false});
        let mainMenu = this.refs[`accordion_${this.props.screen.screen_id}`];
        TweenLite.set(mainMenu, {height:"auto"});
        TweenLite.from(mainMenu, objectConstants.ACCORDION_BUTTON_DURATION, {height: 0, ease: Expo.easeInOut}).eventCallback("onComplete", this.onMenuHandledComplete);
    }

    onMenuHandledComplete(){
        if(this.state.allowStateUpdates){
            this.setState({canClickMenu: true});
        }
    }

    loadScreen(){
        if(this.state.isEnabled) {
            this.props.actions.setNewLessonLocation(this.props.screen.screen_id);
            this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
        }
    }

    setClass() {
        let className = ``;
        if(this.state.isEnabled){
            if(this.state.accordionIsOpen){
                className += `open `;
            }else{
                className += `closed `;
            }

        }else{
            className += `disabled closed `;
        }


        if(this.state.section_status === objectConstants.STATUS_NOT_REQUIRED){
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        }else if(this.state.section_status === objectConstants.STATUS_IN_PROGRESS){
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        }else if(this.state.section_status === objectConstants.STATUS_COMPLETE){
            className += `${objectConstants.CLASS_COMPLETE} `;
        }else{
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }

        return className;
    }

    setIsActive(){
        return this.state.is_current_section ? "active" : "";
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.toggleAccordion();
        }
    }

    loadScreenByKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.loadScreen();
        }
    }

    render(){
        return (

                !appHelper.isDefined(this.props.screen.show_children_screens_in_menu)  || (appHelper.isDefined(this.props.screen.show_children_screens_in_menu) && this.props.screen.show_children_screens_in_menu)
                ?
                    <div className={`menu-nav-accordion`} >
                       <div className={`menu-nav-accordion-btn ${this.setClass()}`} onClick={this.toggleAccordion} onKeyDown={this.setKeyboardAccessibility} tabIndex="0" role="link" id={`menuNavAccordionBtn_${this.props.screen.screen_id}`}>
                        <div className="label-padding" dangerouslySetInnerHTML={{__html:this.state.locale.title}} />
                       </div>
                        <div className="accordion-list" ref={`accordion_${this.props.screen.screen_id}`} role="menu">
                            {this.props.screen.childScreens.map(childScreen =>
                                <MainMenuItem
                                    key={childScreen.screen_id}
                                    screen={childScreen}
                                    current_screen_id={this.state.current_screen_id}
                                    className="list-group-item list-group-item-action"
                                    isAccessible={this.state.accordionIsOpen}
                                />
                            )}
                        </div>
                    </div>
                :
                    <div className={`menu-nav-item ${this.setClass()} ${this.setIsActive()}`} onClick={this.loadScreen} onKeyDown={this.loadScreenByKeyboardAccessibility} dangerouslySetInnerHTML={{__html:this.state.locale.title}} role="link" tabIndex="0" id={`menuNavItem_${this.props.screen.screen_id}`}/>
        );
    }

}

MainMenuAccordionBtn.propTypes = {
    screen: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    bite_id: PropTypes.number.isRequired,
    screen_id: PropTypes.number.isRequired,
    userBite: PropTypes.object.isRequired,
    userScreen: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    //current_screen_id: PropTypes.string.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    let bite_id = appHelper.getBiteByScreenId(state.trackingData.lesson_location);
    let screen_id = ownProps.screen.screen_id;

    let userBite = _.find(state.userData.bites, function(bites) {
        return bites.bite_id === bite_id;
    });

    let userScreen = _.find(userBite.screens, function(screen) {
        return screen.screen_id === screen_id;
    });

    let lang = state.userData.lang;

    return {
        screen: ownProps.screen,
        userData: state.userData,
        bite_id: bite_id,
        screen_id: screen_id,
        userBite: userBite,
        userScreen: userScreen,
        trackingData: state.trackingData,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, mainMenuActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainMenuAccordionBtn);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/mainMenu/MainMenuAccordionBtn.js
 **/